













































































































import Vue from 'vue'
import {
  defaultPosterImage,
  checkIcon,
  MOBILE_CATEGORY_ITEM_HEADING_MAX_LENGTH,
  defaultAssessmentImage
} from '../../helper/constants'
import { getMobileTheme } from '@/helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: {
    BaseIcon
  },
  props: {
    post: {
      type: Object
    },
    categoryId: {
      type: String
    },
    completed: {
      type: Boolean,
      default: false
    },
    available: {
      type: Boolean,
      default: true
    },
    isLocked: {
      type: Boolean
    }
  },
  computed: {
    posterImage(): string {
      const contentWiseDefaultImage = this.post.contentType === 'quiz' ? defaultAssessmentImage : defaultPosterImage
      return this.post.posterImage || contentWiseDefaultImage
    },
    productId(): string {
      return this.post.productId
    },
    device(): string {
      return this.$store.getters.device
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    isBuilder(): boolean {
      return this.$route.query.builder === 'true'
    },
    postContentType(): string {
      return this.post.contentType ? this.post.contentType : ''
    }
  },
  data() {
    return {
      checkIcon,
      headingLimit: MOBILE_CATEGORY_ITEM_HEADING_MAX_LENGTH
    }
  },
  methods: {
    openPost() {
      if (!this.available) {
        return
      }
      this.$router.push({
        name:
          this.post.contentType === 'quiz' && this.newMobileScreens
            ? 'mobile-quiz-overview'
            : 'post-overview',
        params: {
          id: this.productId,
          category_id: this.categoryId,
          post_id: this.post.id
        },
        query: {
          template_id: this.$route.query.template_id
        }
      })
    },
    getMobileTheme
  }
})
